import ProfilePage from "./pages/ProfilePage";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardPage from "./pages/Dashboard";
import ErrorPage from "./pages/ErrorPage";
import NotFoundPage from "./pages/NotFound";
import OnboardingAgreementPage from "./pages/onboarding/Agreement";
import OnboardingIndividualPage from "./pages/onboarding/Individual";
import OnboardingBusinessPage from "./pages/onboarding/Business";
import OnboardingTrustPage from "./pages/onboarding/Trust";
import OnboardedRoute from "./components/OnboardedRoute";
import InvoicesPage from "./pages/InvoicesPage";
import FamilyManagementDashboard from "./pages/FamilyManagementDashboard";
import BusinessFormPage from "./pages/BusinessFormPage";
import TrustFormPage from "./pages/TrustFormPage";
import CharitableOrganizationFormPage from "./pages/CharitableOrganizationFormPage";
import VendorFormPage from "./pages/VendorFormPage";
import AccountingPage from "./pages/Accounting";
import ConciergeDashboardPage from "./pages/ConciergeDashboard";
import ConciergeRoute from "./components/ConciergeRoute";
import AuthRedirect from "./AuthRedirect";
import BankAccountFormPage from "./pages/BankAccountFormPage";
import BrokerageCustodianFormPage from "./pages/BrokerageCustodianFormPage";
import InsuranceCompanyFormPage from "./pages/InsuranceCompanyFormPage";
import ContactFormPage from "./pages/ContactFormPage";
import MessagingPage from "./pages/MessagingPage";

interface AppRoute {
    path: string;
    element: React.ReactNode;
    requiresAuth?: boolean;
    requiresOnboarding?: boolean;
    concierge?: boolean;
    title?: string;
}

const AppRoutes = () => {
    const appRoutes: AppRoute[] = [
        {
            path: "/",
            element: <MessagingPage />,
            requiresOnboarding: true,
            title: "Messages",
        },
        {
            path: "/error",
            element: <ErrorPage />,
            title: "Error",
        },
        {
            path: "/dashboard",
            element: <DashboardPage />,
            requiresOnboarding: true,
            title: "Dashboard",
        },
        {
            path: "/profile",
            element: <ProfilePage />,
            requiresOnboarding: true,
            title: "Profile",
        },
        {
            path: "/messages",
            element: <MessagingPage />,
            requiresOnboarding: true,
            title: "Messages",
        },
        {
            path: "/onboarding/agreement",
            element: <OnboardingAgreementPage />,
            requiresAuth: true,
            title: "Agreement"
        },
        {
            path: "/onboarding/individual",
            element: <OnboardingIndividualPage />,
            requiresAuth: true,
            title: "Individual Information"
        },
        {
            path: "/onboarding/business",
            element: <OnboardingBusinessPage />,
            requiresAuth: true,
            title: "Business Information"
        },
        {
            path: "/onboarding/trust",
            element: <OnboardingTrustPage />,
            requiresAuth: true,
            title: "Trust Information"
        },
        {
            path: "/invoices",
            element: <InvoicesPage />,
            requiresOnboarding: true,
            title: "Invoices",
        },
        {
            path: "/accounting",
            element: <AccountingPage />,
            requiresOnboarding: true,
            title: "Accounting",
        },
        {
            path: "/family-management/:familyId",
            element: <FamilyManagementDashboard />,
            requiresAuth: true,
            concierge: true,
            title: "Family Management"
        },
        {
            path: "/family-management/:familyId/business/add",
            element: <BusinessFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Add Business"
        },
        {
            path: "/family-management/:familyId/business/edit",
            element: <BusinessFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Edit Business"
        },
        {
            path: "/family-management/:familyId/trust/add",
            element: <TrustFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Add Trust"
        },
        {
            path: "/family-management/:familyId/trust/edit",
            element: <TrustFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Edit Trust"
        },
        {
            path: "/family-management/:familyId/charitable-organization/add",
            element: <CharitableOrganizationFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Add Charitable Organization"
        },
        {
            path: "/family-management/:familyId/charitable-organization/edit",
            element: <CharitableOrganizationFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Edit Charitable Organization"
        },
        {
            path: "/family-management/:familyId/brokerageCustodian/add",
            element: <BrokerageCustodianFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Add Brokerage/Custodian"
        },
        {
            path: "/family-management/:familyId/brokerageCustodian/edit",
            element: <BrokerageCustodianFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Edit Brokerage/Custodian"
        },
        {
            path: "/family-management/:familyId/insurance-company/add",
            element: <InsuranceCompanyFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Add Insurance Company"
        },
        {
            path: "/family-management/:familyId/insurance-company/edit",
            element: <InsuranceCompanyFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Edit Insurance Company"
        },
        {
            path: "/family-management/:familyId/vendor/add",
            element: <VendorFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Add Vendor"
        },
        {
            path: "/family-management/:familyId/vendor/edit",
            element: <VendorFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Edit Vendor"
        },
        {
            path: "/family-management/:familyId/contact/add",
            element: <ContactFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Add Contact"
        },
        {
            path: "/family-management/:familyId/contact/edit",
            element: <ContactFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Edit Contact"
        },
        {
            path: "/concierge-dashboard",
            element: <ConciergeDashboardPage />,
            requiresAuth: true,
            concierge: true,
            title: "Concierge Dashboard"
        },
        {
            path: "/auth-redirect",
            element: <AuthRedirect />
        },
        {
            path: "/family-management/:familyId/bankaccount/add",
            element: <BankAccountFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Add Bank Account"
        },
        {
            path: "/family-management/:familyId/bankaccount/edit",
            element: <BankAccountFormPage />,
            requiresAuth: true,
            concierge: true,
            title: "Edit Bank Account"
        },
        {
            path: "*",
            element: <NotFoundPage />,
            title: "Not Found"
        }
    ];

    return (appRoutes.map((route) =>
    ({
        key: route.path,
        path: route.path,
        element:
            route.requiresOnboarding ? (
                <OnboardedRoute>{route.element}</OnboardedRoute>
            ) : (
                route.requiresAuth ? (
                    <ProtectedRoute>{route.element}</ProtectedRoute>
                ) :
                    route.concierge ? (
                        <ConciergeRoute>{route.element}</ConciergeRoute>
                    ) : (
                        route.element
                    )
            )
    }
    )));
};

export default AppRoutes;
